import { Injectable } from '@angular/core';
import { ReportTableComponent } from '../components/report-table/report-table.component';

@Injectable({
  providedIn: 'root'
})

export class RequestHelperService {
  private _table?: ReportTableComponent;

  get table() {
    return this._table;
  }

  set table(i) {
    this._table = i;
  }
}
